import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';

export function AuthGuard({ children }: { children: React.ReactNode }) {
  const storeToken = useAuthStore((s) => s.accessToken);
  const location = useLocation();

  // Check both Zustand store and localStorage to handle race conditions
  const isAuthenticated = !!storeToken || !!localStorage.getItem('admin_access_token');

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ returnUrl: location.pathname }} replace />;
  }

  return <>{children}</>;
}
